import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["up", "down"]

    toggleSorting(e) {
        this.upTarget.classList.toggle("hidden")
        this.downTarget.classList.toggle("hidden")
        this.reverseRooms()
    }

    reverseRooms() {
        const wrapper = document.querySelector("#room-wrapper")
        if (!wrapper) return

        const items = Array.from(wrapper.querySelectorAll(".room-item"))

        items.reverse().forEach(item => wrapper.appendChild(item))
    }
}
